import React from "react";
import HeadCardCandidate from "./HeadCardCandidate";

/**
 * Displays all of the candidates for a given race.
 */
const HeadCardCandidates = ({ options, result, votesCast, shouldShowImages, thereIsAnIncumbent, thereIsAWinner }) => {
  const candidates = result.map((candidate, index) => {
    return (
      <HeadCardCandidate options={options} candidate={candidate} votesCast={votesCast} shouldShowImages={shouldShowImages} thereIsAnIncumbent={thereIsAnIncumbent} thereIsAWinner={thereIsAWinner} key={index} />
    );
  });

  return candidates;
};

export default HeadCardCandidates;
